var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-left bg-base-0 px-2 py-3 border-t border-b border-transparent",class:_vm.classes,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }